import cross from './cross.png';
import crossblk from './crossblk.png';
import hamburger from './hamburger.png';
import logo from './logo.png';

export default {
	cross,
	crossblk,
	hamburger,
	logo
}



// WEBPACK FOOTER //
// ./src/components/Header/images/index.js